if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener("resize", this.handleResize);
        const firstSelectedOption = Array.from(
          this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          )
        ).find((el) => !el.classList.contains("hidden"));
        console.log("firstSelectedOption", firstSelectedOption);
        if (firstSelectedOption) {
          this.showVariantImages(
            firstSelectedOption.getAttribute("data-option-variant-sku")
          );
        }
        this.chooseRightSize();
      }

      chooseRightSize() {
        const interval = setInterval(() => {
          const buttons = document.querySelectorAll('input[type="radio"][data-type="size"]');
          if (buttons.length > 0) {
            const checked = Array.from(buttons).some((button) => button.checked);
            if (!checked) {
              buttons[0].click();
            }
          }
        }, 100);

        setTimeout(() => {
          clearInterval(interval);
        }, 1000);
      }

      handleResize() {
        const selectedOption = this.querySelector(
          "select option[selected], fieldset input:checked"
        );
        if (selectedOption) {
          this.showVariantImages(
            selectedOption.getAttribute("data-option-variant-sku")
          );
        }
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
      }

      showVariantImages(variantSku) {
        if (!variantSku) return;

        const images = document.querySelectorAll(".product__media-item");
        let index = 0;
        let matchingImages = [];
        const visibleImages = [];
        const hiddenImages = [];
        let visibleImageCount = 0;

        if (images) {
          // First, check if any images match at 8 characters
          let hasEightCharMatch = false;
          images.forEach((image) => {
            const imageAlt = image.getAttribute("data-media-alt");
            if (imageAlt && imageAlt.slice(0, 8) === variantSku.slice(0, 8)) {
              hasEightCharMatch = true;
            }
          });

          // Use 8-character matching if available, otherwise use 7-character matching
          const matchLength = hasEightCharMatch ? 8 : 7;

          images.forEach((image) => {
            const imageAlt = image.getAttribute("data-media-alt");
            if (!imageAlt) return;

            if (imageAlt.slice(0, matchLength) === variantSku.slice(0, matchLength)) {
              image.classList.remove("hidden");
              image
                .querySelector(".product__media-zoom")
                ?.setAttribute("data-media-index", index);
              matchingImages.push(image);
              visibleImages.push(image);
              index++;
              visibleImageCount++;
            } else {
              if (window.innerWidth <= 768) {
                image.classList.add("hidden");
              }
              hiddenImages.push(image);
            }
          });

          const container = images[0]?.parentElement;

          if (container) {
            visibleImages.forEach((image) => container.appendChild(image));
            hiddenImages.forEach((image) => container.appendChild(image));
          }

          const isMobile = window.innerWidth < 768;
          if (isMobile && visibleImageCount === 0) {
            matchingImages[0]?.classList.remove("hidden");
            visibleImageCount = 1;
          } else if (!isMobile) {
            images.forEach((image) => {
              const imageAlt = image.getAttribute("data-media-alt");
              if (imageAlt.slice(0, matchLength) !== variantSku.slice(0, matchLength)) {
                image.classList.add("hidden");
              }

              if (matchingImages.length === 1 || matchingImages.length === 2) {
                matchingImages.forEach((image) => (image.style.width = "100%"));
              } else if (matchingImages.length >= 3) {
                matchingImages[0].style.width = "100%";
                for (let i = 1; i < matchingImages.length; i++) {
                  matchingImages[i].style.width = "50%";
                }
              }
            });
          }

          const event = new CustomEvent("update-pagination", {
            detail: {
              visibleImageCount,
            },
          });
          if (document.querySelector("media-gallery")) {
           document.querySelector("media-gallery").dispatchEvent(event);
          }

          const variantChangedEvent = new CustomEvent("variant-changed", {
            detail: { variantSku },
          });
          if (document.querySelector("media-gallery")) {
            document
            .querySelector("media-gallery")
            .dispatchEvent(variantChangedEvent);
          }
        }
      }

      connectedCallback() {
        this.addEventListener("change", (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.showVariantImages(
            target?.getAttribute("data-option-variant-sku")
          );
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
            {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            }
          );
          document.dispatchEvent(
            new CustomEvent("variant:changed", {
              detail: {
                variant: this.currentVariant,
              },
            })
          );
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          target.selectedOptions[0].setAttribute("selected", "selected");

          const swatchValue =
            target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value] > .swatch");
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              "unset"
            );
            selectedDropdownSwatchValue.classList.add("swatch--unavailable");
          }

          selectedDropdownSwatchValue.style.setProperty(
            "--swatch-focal-point",
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
          );
        } else if (tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(`.product-form__input`)
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
